module.exports = __webpack_public_path__ + "img/企业统计 类型.41883858.png";